// extracted by mini-css-extract-plugin
module.exports = {"body":"modal-module__body___qb8H7","root":"modal-module__root___PUdpz","overlay":"modal-module__overlay___2vadS","close":"modal-module__close___2c4-g"};